module.exports = __webpack_public_path__ + "img/coctail.a6bbab31.svg";